// extracted by mini-css-extract-plugin
module.exports = {"no-processors":"NoProcessors-module__no-processors___1M7ZB","noProcessors":"NoProcessors-module__no-processors___1M7ZB"};